module.exports = __webpack_public_path__ + "img/nipc-logo.7bfd9560.png";